import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { ListaCandidatos } from './../lista-candidatos';

@Component({
  selector: 'app-card-candidato',
  templateUrl: './card-candidato.component.html',
  styleUrls: ['./card-candidato.component.css']
})
export class CardCandidatoComponent implements OnInit {
public id:string;
public nome:string;
public cargo:string;
public numero:string;
public apelido:string;
public foto:any;

  constructor(private route:ActivatedRoute) {
    
   }

  ngOnInit() {
   let id = this.route.snapshot.paramMap.get('id');
   console.log('id ' + id);
   let res = new ListaCandidatos().getListById(id);
 console.log('tam ' +JSON.stringify(res));
   if(res !== null){
      this.id = res.id.toString();
      this.nome = res.nome;
      this.cargo = res.cargo ;
      this.numero = res.numero;
      this.apelido = res.apelido;
      this.foto = res.foto;
   }
  }
 

}
